import { Component, OnInit, Input } from "@angular/core";
import { TopNavDropdownItem } from "../../classes/navbar";
import { WindowRef } from "../../window/WindowRef";
import { KpiService } from "../../kpi/kpi.service";
import { MatDialog } from "@angular/material/dialog";
import { TopNavBtnComponent } from "../top-nav-btn/top-nav-btn.component";

@Component({
  selector: "navbar-hamburger",
  templateUrl: "./navbar-hamburger.component.html",
  styleUrls: ["./navbar-hamburger.component.scss"],
})
export class NavbarHamburgerComponent
  extends TopNavBtnComponent
  implements OnInit {
  @Input() isAdmin: boolean;
  @Input() isRestrictedUser: boolean;
  @Input() hasDataWall: boolean;
  @Input() hostname: string;
  @Input() dropdownItems: Array<TopNavDropdownItem>;
  @Input() rgpTenantId: string;
  constructor(
    public winRef: WindowRef,
    public kpiService: KpiService,
    public dialog: MatDialog
  ) {
    super(winRef, kpiService, dialog);
  }

  ngOnInit() {}

  canShowDropdownItem(dropdownItem: TopNavDropdownItem) {
    return (
      (dropdownItem.isAdminRestricted ? this.isAdmin : true) &&
      (dropdownItem.hideFromRestrictedUser ? !this.isRestrictedUser : true) &&
      (dropdownItem.needsDataWallSub ? this.hasDataWall : true)
    );
  }

  clickLink(dropdownItem) {
    if (dropdownItem.otherReportsUrl) {
      this.openOtherReportsLink(dropdownItem.otherReportsUrl);
    } else if (dropdownItem.title == "Upgrade") {
      this.selectBtn("upgrade");
    } else {
      this.trackEvent(
        dropdownItem.ninthGradeSuccessUrl
          ? "Ninth Grade Success"
          : dropdownItem.title
      );
    }
  }
}
